<template>
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table content-table-striped table-hover table-h">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-2 td-aligned">
                Fecha
              </th>
              <th class="col-3 td-aligned">
                Tipo
              </th>
              <th class="col-2 td-aligned">
                Título
              </th>
              <th class="col-3 td-aligned">
                Comentario
              </th>
              <th class="col-1 td-aligned" />
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.itemAttachmentId" class="row">
              <td class="col-md-2 col-sm-12 td-aligned">
                <span>{{ formatDate(item.documentDate) }}</span>
              </td>
              <td class="col-md-3 col-sm-12 td-aligned">
                <span>{{ item.itemAttachmentTypeDesc }}</span>
              </td>
              <td class="col-md-2 col-sm-12 td-aligned">
                <span>{{ item.fileName }}</span>
              </td>
              <td class="col-md-3 col-sm-12 td-aligned">
                <span class="break-long-text">{{ item.comment }}</span>
              </td>
              <td class="col-md-2 col-sm-12 td-aligned">
                <button
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-toggle="dropdown"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-for="menuItem in actions"
                    :key="menuItem.text"
                    class="dropdown-item cursor-pointer"
                    href="javascript:void(0)"
                    :class="
                      ishiddenForAttachmentTypeCode(menuItem, item)
                        ? 'hidden'
                        : ''
                    "
                    v-bind="menuItem.dataAttributes"
                    @click="handle_function_call(menuItem.method, item)"
                  >
                    <em :class="menuItem.iconClass" />
                    {{ menuItem.text }}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-12">
      <AttachDocument
        :document="document"
        :editing="edit"
        :types="documentTypes"
        :allowed-files="allowedFiles"
        :validation-messages="validationMessages"
        :submitted="submitted"
        :comment-max-length="commentMaxLength"
        :can-show-save="canShowSave"
        @cancel="cancel"
        @save="save"
        @enableEditing="enableEditing"
        @fileUploaded="getDocuments"
      />
    </div>

    <div v-if="customErrorMsg" class="p-3 mt-n4">
      <div class="d-inline mr-2">
        <em class="far fa-exclamation-triangle text-danger" />
      </div>
      <p class="text-left d-inline text-danger">
        {{ customErrorMsg }}
      </p>
    </div>

    <customModal
      ref="popup"
      :message-box="{
        title: 'Alerta',
        messageCode: '0547',
        size: 'modal-lg',
        message: message.areYouSureToDelete,
        type: 'confirm',
        icon: 'fa fa-exclamation',
      }"
      :success-callback="deleteFile"
      :cancel-callback="onCloseModal"
    />
  </div>
</template>

<script>
import mixWait from '@/mixin/loading.mixin';
import moment from 'moment';
import mixAlert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';
import AttachDocument from './AttachDocument';
import customModal from '@/components/common/modal/custommodal';

export default {
  name: 'DocumentManager',
  meta: {
    description: 'Componente para gestionar los documentos ',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  mixins: [mixAlert, mixWait],
  components: {
    AttachDocument,
    customModal,
  },
  props: {
    id: {
      type: String,
      default: '',
      required: true,
      meta: {
        description: '	Id del componente Documents',
        example: 'IdDocuments',
      },
    },
    documentCodeType: {
      type: String,
      default: '',
      required: true,
      meta: {
        description: 'ESpecifica el tipo de código del documento',
        example: 'Texto requerido',
      },
    },
    methods: {
      type: Object,
      default: () => {},
      required: true,
      meta: {
        description: 'Manejador del componente documentos',
        example: '{ key1: value1, key2: value2 }',
      },
    },
    menuActions: {
      type: Array,
      default: () => [],
      required: true,
      meta: {
        description: 'Especifica acciones del menu',
        example: '[]',
      },
    },
    allowedFiles: {
      type: String,
      default: '*',
      required: true,
      meta: {
        description: 'Limita los archivos permitidos',
        example: '*',
      },
    },
    validationCodes: {
      type: Array,
      default: () => ['0636'],
      required: false,
      meta: {
        description: 'Especifica el código de validación',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    requiredDocumentTypes: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Especifica documentos requeridos ',
        example: '[]',
      },
    },
    successMessageCode: {
      type: String,
      default: '0636',
      meta: {
        description: 'Maneja el código de mensajes exitosos',
        example: 'Texto requerido',
      },
    },
    disableDuplicatedTypes: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Propiedad que deshabilita duplicados',
        example: '[8, 15, 16, 23]',
      },
    },
    submitted: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Presentado por...',
        example: 'true',
      },
    },
    excludeDocumentsType: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Excluye tipo de documentos',
        example: '[]',
      },
    },
    customErrorMsg: {
      type: String,
      default: () => '',
    },
    commentMaxLength: {
      type: Number,
      default: () => 500,
    },
    canShowSave: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      documentTypes: [],
      documents: [],
      message: {
        errorOnSaving: 'Se ha producido un error al guardar el documento',
        errorToFetch: 'Ha ocurrido un error al consultar los datos.',
        errorToDownload: 'Ha ocurrido un error al descargar la descarga.',
        successOnDelete: 'Documento fue eliminado exitosamente.',
        areYouSureToDelete: '¿Está seguro que desea eliminar el documento?',
        empty: '',
        missingFields: 'Se requiere completar todos los campos para continuar.',
        notAllowedToDelete: 'No puedes eliminar este documento; es requerido.',
        notDuplicatedTypeAllowed:
          'Ya el formulario cuenta con el documento de tipo {0}',
      },
      document: {
        Id: null,
        documentTypeId: 0,
        attachment: null,
        date: new Date(),
        comment: '',
        name: '',
      },
      list: {
        type: Array,
        default: () => [],
        required: true,
      },
      edit: false,
      validationMessages: {
        type: Array,
        default: () => [],
      },
      nonAllowedDocumentTypes: this.disableDuplicatedTypes,
      actions: this.menuActions,
    };
  },
  created() {
    this.getDocuments();
    this.getDocumentTypesByCode(this.documentCodeType);
    this.validationMessagesByCode();
  },
  mounted() {
    if (this.submitted)
      this.actions = this.actions.filter((e) => e.text == 'Descargar');
  },
  methods: {
    ishiddenForAttachmentTypeCode(menuItem, item) {
      let results =
        menuItem.hidden !== undefined &&
        menuItem.hidden.filter((AttachmentTypeCode) => {
          return AttachmentTypeCode === item.attachmentTypeCode;
        }).length > 0;
      return results;
    },
    getDocuments() {
      this.$ApiGet(this.methods.fetch)
        .then((response) => {
          this.list = response.data;
          this.$emit('getSavedDocuments', this.list);
        })
        .catch((err) => {
          this.response = err;
        });
    },
    getDocumentTypesByCode(code) {
      const url =
        this.methods.documentTypesByCodeType ||
        `api/documents/documenttypes?codetype=`;
      this.$ApiGet(`${url}${code}`).then((response) => {
        let _list = response.data;

        if (this.excludeDocumentsType)
          _list = _list.filter(
            (e) => !this.excludeDocumentsType.includes(e.id)
          );

        this.documentTypes = _list;
      });
    },
    validationMessagesByCode() {
      if (!this.validationCodes) return;

      let request =
        this.methods.validationMessageByCode || `api/validationsmessages?`;

      this.validationCodes.forEach((code, index, collection) => {
        request +=
          index === collection.length - 1
            ? `messageCodes=${code}`
            : `messageCodes=${code}&`;
      });

      this.$ApiGet(request).then((res) => {
        this.validationMessages = res.data;
      });
    },
    downloadFile(doc) {
      const url = this.methods.download || `api/documents/downloaddocument?id=`;
      this.$ApiGet(`${url}${doc.itemAttachmentId}`)
        .then((response) => {
          const byteChars = atob(response.data.content);
          const byteNumbers = new Array(byteChars.length);

          for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          let blob = new Blob([byteArray], {
            type: response.data.contentType,
          });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.filename;
          link.click();
        })
        .catch((err) => {
          this.response = err;
          self.ShowToast(this.message.errorToDownload, '', 'error');
        });
    },
    showConfirmationDelete(document) {
      this.document = {
        Id: document.itemAttachmentId,
        documentTypeId: document.attachmentTypeCode,
        attachment: new File([''], document.fileName, {
          type: 'application/pdf',
        }),
        date: new Date(document.documentDate),
        comment: document.comment,
        name: document.fileName,
      };
    },
    onCloseModal() {
      this.cancel();
    },
    editFile(document) {
      this.document = {
        Id: document.itemAttachmentId,
        documentTypeId: document.attachmentTypeCode,
        attachment: new File([''], document.fileName, {
          type: 'application/pdf',
        }),
        date: new Date(document.documentDate),
        comment: document.comment,
        name: document.fileName,
      };

      this.edit = true;
    },
    async deleteFile() {
      if (
        this.requiredDocumentTypes.some(
          (e) => e == this.document.documentTypeId
        )
      ) {
        this.ShowToast(this.message.notAllowedToDelete, '', 'warning');
        this.cancel();
        return;
      }

      this.$ApiDelete(`${this.methods.delete}${this.document.Id}`)
        .then(() => {
          this.getDocuments();
          this.cancel();
          this.ShowToast(this.message.successOnDelete, '', 'success');
        })
        .catch((err) => {
          this.cancel();
          this.response = err;
        });
    },
    formatDate(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
    handle_function_call(functionName, params) {
      params = params || undefined;
      params == undefined ? this[functionName]() : this[functionName](params);
    },
    cancel() {
      this.document = {
        Id: null,
        documentTypeId: 0,
        attachment: null,
        date: new Date(),
        comment: '',
        name: '',
      };

      this.edit = false;
    },
    getDataAsJson() {
      const data = {
        id: this.id,
        ItemAttachmentId: this.document.Id,
        documentTypeId: this.document.documentTypeId,
        file: this.document.attachment,
        comment: this.document.comment,
        date: this.document.date,
      };

      return objectToFormData(data, { indices: true });
    },
    checkDuplicatedType() {
      if (
        this.nonAllowedDocumentTypes.length === 0 ||
        !this.nonAllowedDocumentTypes.includes(this.document.documentTypeId)
      ) {
        return false;
      }

      const index = this.list.findIndex(
        (x) =>
          x.attachmentTypeCode === this.document.documentTypeId &&
          (x.itemAttachmentId != this.document.Id || !this.document.Id)
      );

      return index !== -1;
    },
    save() {
      const data = this.getDataAsJson();
      let notDuplicatedTypeAllowed = this.message.notDuplicatedTypeAllowed.replace(
        '{0}',
        this.documentTypes.find((e) => e.id === this.document.documentTypeId)
          .name
      );

      if (this.checkDuplicatedType()) {
        this.ShowToast('Alerta', notDuplicatedTypeAllowed, 'error');
        return;
      }

      let url = !this.edit
        ? this.methods.upload
        : this.document.attachment.size > 0
        ? this.methods.upload
        : this.methods.update;

      let promise = new Promise((resolve) => {
        this.$ApiPost(url, data)
          .then((res) => {
            resolve(res.data);
            this.ShowToast(
              '',
              this.getMessage(this.successMessageCode).name,
              'success'
            );
            this.showUpload = false;
            this.cancel();
            this.getDocuments();
          })
          .catch(() => {
            this.ShowToast('Alerta', this.message.errorOnSaving, 'error');
          });
      });
      return promise;
    },
    getMessage(code) {
      return this.validationMessages.find((element) => element.id == code);
    },
    enableEditing() {
      this.edit = true;
    },
  },
};
</script>

<style scoped>
.h-100 {
  height: 100px !important;
}
/*end of text for navigation*/
/***Transparent button for dropdown***/
.btn-transparent {
  background: transparent;
}
.btn-green {
  background: #2db782;
  color: white;
  font-weight: 400;
}
.btn-green:hover {
  color: white;
  text-decoration: none;
}
.border-green {
  border: solid 1px #2db782;
  color: #2db782;
}
.border-green:focus {
  outline: 0;
  box-shadow: none;
}
.dropdown-menu {
  min-width: 9rem;
  padding: 0.5rem 0em;
}
.break-long-text {
  word-break: break-all;
}
.hidden {
  display: none;
}
/***End of Transparent button***/
</style>
